import de_dev from "@juicetechnologyag/jce-texts/smart-juice/de_dev.json";
import en_dev from "@juicetechnologyag/jce-texts/smart-juice/en_dev.json";

const languages = [
  {
    id: "en-GB",
    label: "English",
    locales: ["en-GB", "en", "en-US"],
    messages: en_dev,
  },
  {
    id: "de-DE",
    label: "Deutsch",
    locales: ["de-DE", "de"],
    messages: de_dev,
  },
];

export default languages;
